import * as farmacloud from './farmacloud'
import * as farmapremium from './farmapremium'

let dashboard = {}
const dashboardKey = process.env.VUE_APP_DASHBOARD || 'farmapremium'

if (dashboardKey === 'farmacloud') {
  dashboard = farmacloud
} else {
  dashboard = farmapremium
}

const {
  Auth,
  config,
  routes
} = dashboard

export {
  dashboardKey,
  Auth,
  config,
  routes
}
